import { render, staticRenderFns } from "./annoter.vue?vue&type=template&id=232e6456&scoped=true"
import script from "./annoter.js?vue&type=script&lang=js&external"
export * from "./annoter.js?vue&type=script&lang=js&external"
import style0 from "./annoter.vue?vue&type=style&index=0&id=232e6456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e6456",
  null
  
)

export default component.exports